import { render } from "./IndonesianJournal.vue?vue&type=template&id=51efaeb6&scoped=true"
import script from "./IndonesianJournal.vue?vue&type=script&lang=js"
export * from "./IndonesianJournal.vue?vue&type=script&lang=js"

import "./IndonesianJournal.vue?vue&type=style&index=0&id=51efaeb6&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51efaeb6"]])

export default __exports__